// extracted by mini-css-extract-plugin
export default {"melodyVideo":"QJ-z","isFullWidth":"RJ-z","landingPageVideo":"SJ-z","play":"TJ-z","iframeVideo":"UJ-z","playHidden":"VJ-z","fullwidth":"WJ-z"};